import type { SelectOption } from '@/components/ui/Select';

/**
 * Funding-stage enum - values mirror the backend Prisma `FundingStage` enum
 * exactly (the wire value is the enum member name). Shared between the
 * Startup Profile's own Funding Stage field and the Investor Profile's
 * Preferred Funding Stages (`docs/reference/data-fields.md`: "list identical
 * to investor Preferred Funding Stages" / the client CSV 2026-07-16 note -
 * option lists must be string-identical for the match).
 */
export const FUNDING_STAGE_OPTIONS: SelectOption[] = [
  { value: 'pre_seed', label: 'Pre-Seed (including Friends and Family)' },
  { value: 'seed', label: 'Seed' },
  { value: 'series_a', label: 'Series A' },
  { value: 'series_b', label: 'Series B' },
  { value: 'series_c_growth', label: 'Series C or Growth' },
];
